<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} cấu hình đăng ký tư vấn khám
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Mã ứng dụng" prop="app_code">
                      <el-input v-model.trim="mData.tableRules.dataSearch.value.app_code" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Tên ứng dụng" prop="app_name">
                      <el-input v-model="mData.tableRules.dataSearch.value.app_name" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Phí dịch vụ (%)" prop="percentage_discount">
                      <el-input-number
                        type="number"
                        v-model="mData.tableRules.dataSearch.value.percentage_discount"
                        clearable
                        :min="mData.dataDefault.limitPercentOptions.min"
                        :max="mData.dataDefault.limitPercentOptions.max"
                        :controls="mData.dataDefault.limitPercentOptions.controls"
                        prefix-icon="far fa-percent"
                      ></el-input-number>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Phí dịch vụ (Số tiền)" prop="money_discount">
                      <ElementUIMoney
                          v-model="mData.tableRules.dataSearch.value.money_discount"
                          label=""
                          :outlined="true"
                          :clearable="true"
                          :options="options"
                        />
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button>
            </div>
          </b-col>
        </b-row>
        <!-- Table -->
        <el-table
          :data="mData.tableRules.data"
          border
          max-height="440"
          style="width: 100%"
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="index" label="STT" width="50" align="center">
            <template slot-scope="scope">
              {{ mData.tableRules.offset + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column
            prop="app_code"
            :sortable="mData.tableRules.allowSorting"
            label="Mã ứng dụng"
            align="center"
            width="130"
          ></el-table-column>
          <el-table-column prop="app_name" label="Tên ứng dụng" min-width="185"></el-table-column>
          <el-table-column prop="percentage_discount" label="Phí dịch vụ (%)" min-width="85" align="right"></el-table-column>
          <el-table-column prop="money_discount" label="Phí dịch vụ (Số tiền)" min-width="110" align="right">
            <template slot-scope="scope">
              {{ scope.row.money_discount ? fn_formatMoney(scope.row.money_discount) : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="disabled" label="Trạng thái" min-width="85" align="center"></el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="190">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>
              <el-button
                v-if="scope.row.disabled == 'Mở khóa'"
                size="mini"
                @click="fn_handle('lock',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_lock"
              >
                <i class="el-icon-lock icons"></i>
              </el-button>
              <el-button
                v-if="scope.row.disabled == 'Khóa'"
                size="mini"
                @click="fn_handle('unlock',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_unlock"
              >
                <i class="el-icon-unlock icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- Pagination -->
        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import CauHinhDangKyTuVanKhamModel from "./CauHinhDangKyTuVanKhamModel";
import CauHinhDangKyTuVanKhamApi from "../../../moduleApi/CauHinhDangKyTuVanKhamApi";
import ElementUIMoney from "../../../component/ElementUiMoney.vue";

export default {
  components: {
    ElementUIMoney
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 100,
        precision: 0,
      },
      mData: {
        moduleName: "CauHinhDangKyTuVanKham", //requied
        tableRules: MethodService.copyObject(CauHinhDangKyTuVanKhamModel.tableRules),
        dataDefault: {
          listMedicalFacility: [],
          limitPercentOptions: {
            min: 0,
            max: 100,
            controls: false
          }
        }
      }
    };
  },

  methods: {
    async fn_initDataDefault() {
    },

    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowSorting) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        })
        .catch(()=>{});
      }

      const res = await CauHinhDangKyTuVanKhamApi.list(dataFilter);

      this.mData.tableRules.data = await this.changeData(res.result);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {
      data.forEach(e => {
        if (e.disabled == "LOCK") {
          e.disabled = "Khóa";
        } else if (e.disabled == "UNLOCK") {
          e.disabled = "Mở khóa";
        }
      })
      return data;
    },

    //click button
    async fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "lock") {
        this.$confirm(LanguageService.lang.c_lockConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(async () => {
            let data = {
              id: row.id,
              app_code: row.app_code,
              disabled: "LOCK"
            }
            await CauHinhDangKyTuVanKhamApi.update(data);
            await this.fn_initTable();
          })
          .catch(() => {});
      }
      if (type == "unlock") {
        this.$confirm(LanguageService.lang.c_unlockConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(async () => {
            let data = {
              id: row.id,
              app_code: row.app_code,
              disabled: "UNLOCK"
            }
            await CauHinhDangKyTuVanKhamApi.update(data);
            await this.fn_initTable();
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await CauHinhDangKyTuVanKhamApi.delete(id);
      await this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (this.mData.tableRules.dataSearch.value.app_name) {
            this.mData.tableRules.dataSearch.value.app_name = this.mData.tableRules.dataSearch.value.app_name.trim();
          }
          if (this.mData.tableRules.dataSearch.value.app_code) {
            this.mData.tableRules.dataSearch.value.app_code = this.mData.tableRules.dataSearch.value.app_code.trim();
          }
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_formatMoney(val) {
      return MethodService.formatMoney(val);
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_hashUrl() {
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  async mounted() {
    // await this.fn_initDataDefault();
    await this.fn_initTable();
  }
};
</script>

<style lang="css" scoped>
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
</style>
